const KNOWN_TAG_KEYS = new Set([
    'customerName',
    'customerEmail',
    'customerHomePhone',
    'customerWorkPhone',
    'customerMobilePhone',
    'customerNumber',
    'serviceDate',
    'jobNumber',
    'serviceFullAddress',
    'serviceAddress',
    'serviceCityStateZip',
    'jobId',
    'dateEstimated',
    'webId',
    'scheduleJobUrl',
    'billingName',
    'billingAddress',
    'billingCityStateZip',
    'jobDateDone',
    'jobAmountCharged',
    'sealcoatingPrice',
    'hasPatchwork',
    'patchworkPrice',
    'hasAutoAdjustments',
    'autoAdjustments',
    'adjustmentName',
    'adjustmentAmount',
    'totalPriceWithNoDiscounts',
    'amountDue',
    'totalPrice',
    'hasExtraServices',
    'extraServices',
    'serviceName',
    'serviceDescription',
    'servicePrice',
    'estimateNotes',
    'hasEstimateNotes',
    'isReceipt',
    'email_images_base_url',
    'subject',
]);

const KNOWN_SPACED_TAGS = [
    'customer name',
    'customer email',
    'customer home phone',
    'customer work phone',
    'customer mobile phone',
    'customer web id',
    'property address',
    'billing name',
    'billing address',
    'billing city',
    'billing state',
    'billing zip',
    'job date done',
    'job amount charged',
];

const BLOCK_HELPER_PATTERN = /^(#(if|each|unless)\s+[\w.]+|\/(if|each|unless)|else)$/;

export function extractHandlebarTags(text: string): string[] {
    return text.match(/\{\{[^{}]*\}\}/g) ?? [];
}

export function stripHtmlToText(html: string): string {
    return html
        .replace(/<[^>]*>/g, '')
        .replace(/&nbsp;/gi, ' ')
        .replace(/&amp;/gi, '&');
}

export function findUnknownHandlebarTags(text: string): string[] {
    const unknown: string[] = [];
    for (const tag of extractHandlebarTags(text)) {
        const inner = tag.slice(2, -2).trim();
        if (BLOCK_HELPER_PATTERN.test(inner)) continue;
        const key = inner.startsWith('this.') ? inner.slice(5) : inner;
        if (KNOWN_TAG_KEYS.has(key)) continue;
        if (KNOWN_SPACED_TAGS.includes(key.toLowerCase())) continue;
        if (!unknown.includes(tag)) unknown.push(tag);
    }
    return unknown;
}
